"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUiDialog = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
function useUiDialog() {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const Dialog = react_1.useCallback((uiDialogProps) => (react_1.default.createElement(__1.UiDialog, Object.assign({}, uiDialogProps, { isOpen: isOpen, setIsOpen: setIsOpen, onClose: close }))), [isOpen]);
    function open() {
        setIsOpen(true);
    }
    function close() {
        setIsOpen(false);
    }
    function toggleIsOpen() {
        setIsOpen(!isOpen);
    }
    return {
        open,
        close,
        Dialog,
        isOpen,
        toggleIsOpen,
        extendToggle: (toggle) => react_1.default.cloneElement(toggle, { onClick: open }),
    };
}
exports.useUiDialog = useUiDialog;
